import { useEffect, useRef,useState } from "react";
import Reveal from "./ui/reveal";
import DrawLine from "./ui/drawline";
import Magnetic from "./ui/magnetic";
import SplitText from "./ui/splittixt"
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Tilt3D from "./ui/tilt3D";
import UseInView from "./ui/useInView";

const HeroSection = () => {
  const videoRef = useRef(null); const sectionRef = useRef(null); const overlayRef = useRef(null);
  useEffect(() => {
    let raf;
    const update = () => {
      if (!videoRef.current || !sectionRef.current) return;
      const y = window.scrollY;
      const h = sectionRef.current.offsetHeight;
      const p = Math.min(y / h, 1);
      videoRef.current.style.transform = `scale(${1 + p * 0.15})`;
    };
    const onScroll = () => { raf = requestAnimationFrame(update); };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); cancelAnimationFrame(raf); };
  }, []);
  return (
    <section ref={sectionRef} className="relative h-screen min-h-[700px] overflow-hidden" style={{ position: "sticky", top: 0, zIndex: 1 }} data-testid="v13-hero-section">
      <video ref={videoRef} className="absolute inset-0 w-full h-full object-cover will-change-transform" autoPlay muted loop playsInline poster="assets/home_banner_preview.png" style={{transform:"scale(1)"}}>
        <source src="assets/home_banner_video.mp4" type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50" />
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center pt-2"><div className="w-1 h-2 bg-white/80 rounded-full v13-scroll-bob" /></div>
      </div>
    </section>
  );
};

const AnimatedCounter = ({ end, suffix="" }) => {
  const [count,setCount]=useState(0);const [ref,vis]=UseInView();
  useEffect(()=>{if(!vis)return;const t=parseInt(end.replace(/,/g,""));const s=Date.now();const a=()=>{const p=Math.min((Date.now()-s)/3500,1);setCount(Math.floor((1-Math.pow(1-p,4))*t));if(p<1)requestAnimationFrame(a)};requestAnimationFrame(a)},[vis,end]);
  return <span ref={ref}>{count.toLocaleString()}{suffix}</span>;
};

// ===================== ABOUT (updated content from Gillco Profile) =====================
const AboutSection = () => {
  const milestones = [
    { number: "25", suffix: "+", label: "Years of Excellence" },
    { number: "19", suffix: "+", label: "Projects Delivered" },
    { number: "6000", suffix: "+", label: "Happy Families" },
    { number: "43", suffix: "M+", label: "Sq. Ft. Developed" },
  ];
  return (
    <section className="about-section" data-testid="v13-about-section">
      <div className="section-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          <div>
            <Reveal><span className="about-label" style={{ color: "#C4A265" }}>Introduction</span></Reveal>
            <h2 className="about-title"><SplitText text="The Gillco Group" /></h2>
            <DrawLine className="h-[3px] w-16 bg-[#C4A265] mb-8 mt-2" delay={0.3} />
            <Reveal delay={0.2}><p className="about-text mb-8" style={{ textAlign: "justify" }}>Gillco Group stands as a legacy of trust, disciplined growth, and enduring value, deeply rooted in the ethos of Punjab. Founded in 2001 by Mr. Ranjit Singh Gill and Mrs. Paramjit Gill, the Group was established with a clear vision to unlock land potential and create integrated communities for modern India.</p></Reveal>
            <Reveal delay={0.3}><p className="about-text mb-10" style={{ textAlign: "justify" }}>Under the present leadership, Gillco has evolved into a diversified real estate enterprise, delivering residential and commercial developments defined by quality, reliability, thoughtful design, and long-term value creation for customers and partners — bolstering its position as a leader in North India's real estate landscape.</p></Reveal>
            <Reveal delay={0.4}>
              <Magnetic><Link to={`/about`} className="btn-secondary" data-testid="v13-about-cta">Discover Our Legacy <ArrowRight size={16} /></Link></Magnetic>
            </Reveal>
          </div>
          <div className="grid grid-cols-2 gap-4" data-testid="v13-milestones">
            {milestones.map((item, index) => (
              <Reveal key={index} delay={0.15 * index} direction="scale">
                <Tilt3D className="milestone-counter h-full">
                  <div className="milestone-number"><AnimatedCounter end={item.number} suffix={item.suffix} /></div>
                  <div className="milestone-label">{item.label}</div>
                </Tilt3D>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export { AnimatedCounter, AboutSection };
export default HeroSection;
